import React from 'react';
import { cn } from '@app/shared/utils/common';

export function PulsingGlowWrapper({
  children,
  borderWidth = 3,
  className = '',
  pulsationClassName = '',
}: {
  children: React.ReactNode;
  borderWidth?: number;
  className?: string;
  pulsationClassName?: string;
}) {
  return (
    <div
      className={cn(
        'relative rounded-2xl transition-all duration-500 ',
        className,
        `p-[${borderWidth}px]`
      )}
    >
      <div
        className={cn(
          'absolute inset-0 size-[110px] -top-[3px] -left-[2px] rounded-2xl bg-[linear-gradient(180deg,rgba(82,243,255,0.6)_0%,rgba(30,110,255,0.75)_105.74%)] animate-glow-pulse',
          pulsationClassName
        )}
      />

      <div className="relative rounded-2xl transition-all duration-700 animate-grayscale-pulse">
        {children}
      </div>
    </div>
  );
}
